<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="用户id" prop="userId">
        <el-input
          v-model="queryParams.userId"
          placeholder="请输入用户id"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告id" prop="hisReportId">
        <el-input
          v-model="queryParams.hisReportId"
          placeholder="请输入报告id"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标id" prop="observationId">
        <el-input
          v-model="queryParams.observationId"
          placeholder="请输入指标id"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标code" prop="observationCode">
        <el-input
          v-model="queryParams.observationCode"
          placeholder="请输入指标code"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标名称" prop="observationName">
        <el-input
          v-model="queryParams.observationName"
          placeholder="请输入指标名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标结果" prop="observationResult">
        <el-input
          v-model="queryParams.observationResult"
          placeholder="请输入指标结果"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标结果标志" prop="observationResultCode">
        <el-input
          v-model="queryParams.observationResultCode"
          placeholder="请输入指标结果标志"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标结果标志显示" prop="observationResultDisplay">
        <el-input
          v-model="queryParams.observationResultDisplay"
          placeholder="请输入指标结果标志显示"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标单位" prop="observationUnit">
        <el-input
          v-model="queryParams.observationUnit"
          placeholder="请输入指标单位"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="指标正常范围" prop="observationRange">
        <el-input
          v-model="queryParams.observationRange"
          placeholder="请输入指标正常范围"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker clearable
          v-model="queryParams.createDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择创建时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['his:HisDiagnosticReportObservation:add']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['his:HisDiagnosticReportObservation:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['his:HisDiagnosticReportObservation:remove']"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['his:HisDiagnosticReportObservation:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="observationList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="${comment}" align="center" prop="id" />
      <el-table-column label="用户id" align="center" prop="userId" />
      <el-table-column label="报告id" align="center" prop="hisReportId" />
      <el-table-column label="指标id" align="center" prop="observationId" />
      <el-table-column label="指标code" align="center" prop="observationCode" />
      <el-table-column label="指标名称" align="center" prop="observationName" />
      <el-table-column label="指标结果" align="center" prop="observationResult" />
      <el-table-column label="指标结果标志" align="center" prop="observationResultCode" />
      <el-table-column label="指标结果标志显示" align="center" prop="observationResultDisplay" />
      <el-table-column label="指标单位" align="center" prop="observationUnit" />
      <el-table-column label="指标正常范围" align="center" prop="observationRange" />
      <el-table-column label="创建时间" align="center" prop="createDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['his:HisDiagnosticReportObservation:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['his:HisDiagnosticReportObservation:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改His系统报告单项指标对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="用户id" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入用户id" />
        </el-form-item>
        <el-form-item label="报告id" prop="hisReportId">
          <el-input v-model="form.hisReportId" placeholder="请输入报告id" />
        </el-form-item>
        <el-form-item label="指标id" prop="observationId">
          <el-input v-model="form.observationId" placeholder="请输入指标id" />
        </el-form-item>
        <el-form-item label="指标code" prop="observationCode">
          <el-input v-model="form.observationCode" placeholder="请输入指标code" />
        </el-form-item>
        <el-form-item label="指标名称" prop="observationName">
          <el-input v-model="form.observationName" placeholder="请输入指标名称" />
        </el-form-item>
        <el-form-item label="指标结果" prop="observationResult">
          <el-input v-model="form.observationResult" placeholder="请输入指标结果" />
        </el-form-item>
        <el-form-item label="指标结果标志" prop="observationResultCode">
          <el-input v-model="form.observationResultCode" placeholder="请输入指标结果标志" />
        </el-form-item>
        <el-form-item label="指标结果标志显示" prop="observationResultDisplay">
          <el-input v-model="form.observationResultDisplay" placeholder="请输入指标结果标志显示" />
        </el-form-item>
        <el-form-item label="指标单位" prop="observationUnit">
          <el-input v-model="form.observationUnit" placeholder="请输入指标单位" />
        </el-form-item>
        <el-form-item label="指标正常范围" prop="observationRange">
          <el-input v-model="form.observationRange" placeholder="请输入指标正常范围" />
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker clearable
            v-model="form.createDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择创建时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {addHisDiagnosticReportObservation, delHisDiagnosticReportObservation, getHisDiagnosticReportObservation, listHisDiagnosticReportObservation, updateHisDiagnosticReportObservation} from "@/api/his/HisDiagnosticReportObservation";

  export default {
  name: "HisDiagnosticReportObservation",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // His系统报告单项指标表格数据
      observationList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: null,
        hisReportId: null,
        observationId: null,
        observationCode: null,
        observationName: null,
        observationResult: null,
        observationResultCode: null,
        observationResultDisplay: null,
        observationUnit: null,
        observationRange: null,
        createDate: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询His系统报告单项指标列表 */
    getList() {
      this.loading = true;
      listHisDiagnosticReportObservation(this.queryParams).then(response => {
        this.observationList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        userId: null,
        hisReportId: null,
        observationId: null,
        observationCode: null,
        observationName: null,
        observationResult: null,
        observationResultCode: null,
        observationResultDisplay: null,
        observationUnit: null,
        observationRange: null,
        createDate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加His系统报告单项指标";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getHisDiagnosticReportObservation(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改His系统报告单项指标";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateHisDiagnosticReportObservation(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addHisDiagnosticReportObservation(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除His系统报告单项指标编号为"' + ids + '"的数据项？').then(function() {
        return delHisDiagnosticReportObservation(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('his/observation/export', {
        ...this.queryParams
      }, `observation_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
